import {
  Screen,
  ScreenHeader,
  ScreenFooter,
  ScreenBody,
  screenConnect,
} from "@screen";
import { ModalButton, ModalIconLink } from "@modal";
import EditorBee from "./editor_bee.jsx";
import EditorTextarea from "./editor_textarea.jsx";
import EditorHugeRTE from "./editor_hugerte.jsx";
import { ceModalInsertFormOpen } from "@js/actions/studio/campaign_content_section/modal_insert_form.js";
import { ceModalInsertCustomFieldOpen } from "@js/actions/studio/campaign_content_section/modal_insert_custom_field.js";
import { ceModalConvertHTMLToTextOpen } from "@js/actions/studio/campaign_content_section/modal_convert_html_to_text.js";
import { ceModalEditSubjectOpen } from "@js/actions/studio/campaign_content_section/modal_edit_subject.js";
import { ceModalManageCustomRowsOpen } from "@js/actions/studio/campaign_content_section/custom_rows.js";

const ScreenEditor = (props) => {
  let connector = props.connector;

  let editorName =
    props.format === "html" ? props.active_html_editor : "textarea";

  let editor;

  switch (editorName) {
    case "bee":
      editor = <EditorBee connector={connector} />;
      break;
    case "wysiwyg":
      editor = <EditorHugeRTE connector={connector} />;
      break;
    default:
      editor = <EditorTextarea connector={connector} />;
      break;
  }

  let allowInsert = editorName !== "bee";

  let leftLinks = [];

  if (allowInsert) {
    let unsubTag =
      props.format === "text"
        ? "%%unsubscribe_link%%"
        : `<a href="%%unsubscribe_link%%">${t("phrases.unsubscribe_me")}</a>`;

    leftLinks.push(
      <ModalIconLink
        icon="door-open"
        onClick={() => connector.trigger({ type: "insert", value: unsubTag })}
        key="unsub"
      >
        {t(`buttons.unsubscribe`)}
      </ModalIconLink>,
    );
    if (props.format === "html") {
      leftLinks.push(
        <ModalIconLink
          icon="images"
          onClick={() => {
            let $browserTarget = $("#campaign-images-modal");
            $browserTarget.data("campaign_id", props.campaign_id);
            new ImagesBrowser($browserTarget, (url) => {
              let imageTag = $("<img/>")
                .attr("src", url)
                .get(0).outerHTML;
              connector.trigger({ type: "insert", value: imageTag });
            });
          }}
          key="images"
        >
          {t(`buttons.images`)}
        </ModalIconLink>,
      );
    }
    leftLinks.push(
      <ModalIconLink
        icon="justify"
        onClick={() => {
          props.dispatch(ceModalInsertFormOpen(props.format));
        }}
        key="forms"
      >
        {t("buttons.insert_form")}
      </ModalIconLink>,
    );
    leftLinks.push(
      <ModalIconLink
        icon="pencil"
        onClick={() => {
          props.dispatch(ceModalInsertCustomFieldOpen());
        }}
        key="custom_fields"
      >
        {t("buttons.insert_field")}
      </ModalIconLink>,
    );
    if (props.html && props.format === "text") {
      leftLinks.push(
        <ModalIconLink
          icon="import"
          onClick={() => {
            props.dispatch(
              ceModalConvertHTMLToTextOpen(props.client_content_id, connector),
            );
          }}
          key="convert_from_html"
        >
          {t("phrases.react_content.convert_from_html")}
        </ModalIconLink>,
      );
    }
  }

  if ( editorName === "bee" ) {
    leftLinks.push(
      <ModalIconLink
        icon="cogs"
        onClick={() => {
          props.dispatch(ceModalManageCustomRowsOpen());
        }}
        key="custom_fields"
      >
        {t("buttons.manage_custom_rows")}
      </ModalIconLink>,
    );
  }

  return (
    <Screen>
      <ScreenHeader>
        <div className="screen-editor-left-links">{leftLinks}</div>
        <div className="screen-editor-actions">
          <ModalButton
            onClick={() => {
              connector.trigger({
                type: "cancel",
              });
            }}
            text={t("buttons.cancel")}
            diminished
          />
          <ModalButton
            onClick={() => connector.trigger({ type: "save" })}
            text={t("buttons.save")}
          />
        </div>
      </ScreenHeader>
      <ScreenBody className="screen-editor-body">{editor}</ScreenBody>
      <ScreenFooter>
        <div
          onClick={() =>
            props.dispatch(ceModalEditSubjectOpen(props.client_content_id))
          }
          className="screen-editor-footer"
        >
          <p className="subject-container-left">
            <strong>
              {t("phrases.react_content.edit_subject_in_fullscreen.subject")}
            </strong>{" "}
            {props.subject}{" "}
          </p>
          <div className="subject-container-right">
            <strong>
              {t("phrases.react_content.edit_subject_in_fullscreen.edit")}
            </strong>
          </div>
        </div>
      </ScreenFooter>
    </Screen>
  );
};

export default screenConnect(ScreenEditor);
